import { render, staticRenderFns } from "./TypeOfProgramEdit.vue?vue&type=template&id=b70c6d8e"
import script from "./TypeOfProgramEdit.vue?vue&type=script&lang=js"
export * from "./TypeOfProgramEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports